export { default as useMedia } from "./useMedia";
